export enum PushbackEvents {
  AllReviewed = 'All Reviewed',
  AllSigned = 'All Signed',
  Authenticate = 'Authenticate',
  AuthenticateFailed = 'AuthenticateFailed',
  Consent = 'Consent',
  DocumentsDistributed = 'DocumentsDistributed',
  Sign = 'Sign',
  Review = 'Review',
}
